import { createApi } from "./client";
import type { Staff } from "../types/models";

export function listStaffForService(
    apiBase: string,
    companySlug: string,
    serviceId: number,
    locationId?: number | null
): Promise<Staff[]> {
    const api = createApi(apiBase);

    const locationParam = locationId ? `&locationId=${locationId}` : "";

    return api<Staff[]>(
        `/api/companies/${companySlug}/staff?serviceId=${serviceId}${locationParam}`
    );
}
